module.exports = __webpack_public_path__ + "img/infantshome.ff35fd1.png";